import { Grid } from '@mui/material';
import { CustomFieldDefinitionTypes } from '@nx-smartmonkey/shared/domain';
import { Checkbox, HSpacer, RoutalDialog } from '@nx-smartmonkey/ui';
import { ProjectCustomersEntityField } from '../../../../domain/project/projectCustomers/ProjectCustomersEntityField';
import { ProjectCustomersFieldTypes } from '../../../../domain/project/projectCustomers/ProjectCustomersFields';
import Text from '../../../../react-components/Text';

export interface AppField<T> extends Omit<ProjectCustomersEntityField<T>, `id`> {
  id: string;
  text: string;
  enabled: boolean;
  type: ProjectCustomersFieldTypes | CustomFieldDefinitionTypes;
}

interface ManageFieldsDialogProps<T> {
  open: boolean;
  onClose: () => void;
  fields: AppField<T>[];
  onUpdate: (props: { field: AppField<T>; selected: boolean }) => void;
  onUpdateAll: (props: { selected: boolean }) => void;
}

export const ManageFieldsDialog = <T,>({
  open,
  onClose,
  fields,
  onUpdate,
  onUpdateAll,
}: ManageFieldsDialogProps<T>) => {
  const areAllSelected = fields.every((field) => field.enabled);

  const countSelected = fields.filter((field) => field.enabled).length;

  return (
    <RoutalDialog
      open={open}
      onCloseDialog={() => onClose()}
      titleContent={<Text variant="h6" intlId="customers.app.options.manage_fields" />}
      showFooter={false}
      contentStyles={{
        padding: 0,
      }}
    >
      <Grid container direction="column">
        <Grid item style={{ maxHeight: `600px`, overflowY: `auto`, padding: `16px`, paddingTop: 0 }}>
          <Grid
            container
            direction="row"
            alignItems="center"
            justifyContent="flex-end"
            key="select-all"
            style={{
              height: `42px`,
              padding: `0 8px`,
            }}
          >
            <Grid item>
              <Text
                variant="label"
                style={{ fontSize: `13px` }}
                intlId="customers.app.options.manage_fields.num_selected"
                intlValues={{ num: countSelected }}
              />
            </Grid>

            <HSpacer small />

            <Grid item>
              <Text
                variant="button"
                intlId={`customers.app.options.manage_fields.${areAllSelected ? `unselect_all` : `select_all`}`}
                onClick={() => {
                  onUpdateAll({ selected: !areAllSelected });
                }}
              />
            </Grid>
          </Grid>

          {fields.map((field, index) => (
            <Grid
              container
              direction="row"
              alignItems="center"
              key={field.id}
              style={{
                height: `42px`,
                padding: `0 8px`,
                ...(index > 0 ? { borderTop: `1px solid #E0E0E0` } : {}),
              }}
            >
              <Grid item xs={10}>
                <Text>{field.text}</Text>
              </Grid>

              <Grid item container xs={2} justifyContent="end">
                <Checkbox
                  checked={field.enabled}
                  onChange={(event: any) => {
                    const { checked } = event.target;
                    onUpdate({ field, selected: checked });
                  }}
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </RoutalDialog>
  );
};
